module.exports = __webpack_public_path__ + "img/Photoshop.d618ea7e.png";